"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_request_1 = require("../../api_request");
var lodash_1 = require("lodash");
var url_helpers_1 = require("../../shared/url_helpers");
var flash_1 = require("../../../flash");
var hash_util_1 = require("../../../reverb-js-common/hash_util");
var FollowService = /** @class */ (function () {
    function FollowService() {
    }
    FollowService.add = function (params) {
        var _this = this;
        var req = api_request_1.V3.post(url_helpers_1.default.myFollowsSearchPath(), JSON.stringify(params), { contentType: 'application/json' });
        return req.fail(function (err) { _this.fail(err); });
    };
    FollowService.remove = function (follow) {
        var _this = this;
        var req = api_request_1.V3.destroy(hash_util_1.getLink(follow, 'self'));
        req.fail(function (err) { return _this.fail(err); });
        return req;
    };
    FollowService.removeAlert = function (follow) {
        var _this = this;
        var req = api_request_1.V3.destroy(hash_util_1.getLink(follow, 'alert'));
        req.fail(function (err) { return _this.fail(err); });
        return req;
    };
    FollowService.fetch = function (params) {
        var req = api_request_1.V3.get(url_helpers_1.default.myFollowsSearchPath(), params);
        req.fail(function (_xhr, status, err) { throw new Error("failed to fetch follows - status: " + status + ", err: " + err); });
        return req;
    };
    FollowService.fail = function (error) {
        flash_1.flashError(lodash_1.get(error, 'responseJSON.message'));
        throw new Error(lodash_1.get(error, 'responseJSON.message'));
    };
    return FollowService;
}());
exports.default = FollowService;
//# sourceMappingURL=follow_service.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_service.js
// module id = tNMr
// module chunks = 20 21